import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { authzScopeList } from '@/features/authz/api'
import { AuthzTeamCreateForm } from '@/features/authz/components/authz-team-form'

export const Route = createFileRoute('/_app/settings/team/create')({
	async loader({ context }) {
		const { qc } = context
		await qc.ensureQueryData(authzScopeList.qry())
	},
	component: Component,
})

function Component() {
	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/settings', 'Pengaturan'],
					['/settings/team', 'Team'],
					['/settings/team/create', 'Create'],
				]}
			/>
			<PageCard.Root>
				<PageCard.Header title="Tambah Akses Grup" />
				<AuthzTeamCreateForm />
			</PageCard.Root>
		</PageLayout.Root>
	)
}
